var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.049,
    height: 33.049,
    viewBox: "0 0 33.049 33.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-help-circle",
    "data-name": "Icon feather-help-circle",
    transform: "translate(1.25 1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38251",
    "data-name": "Path 38251",
    d: "M33.549,18.274A15.274,15.274,0,1,1,18.274,3,15.274,15.274,0,0,1,33.549,18.274Z",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38252",
    "data-name": "Path 38252",
    d: "M13.635,13.555a4.582,4.582,0,0,1,8.9,1.527c0,3.055-4.582,4.582-4.582,4.582",
    transform: "translate(-2.805 -2.863)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38253",
    "data-name": "Path 38253",
    d: "M18,25.5h0",
    transform: "translate(-2.726 -2.588)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmark);
export default __webpack_public_path__ + "static/media/questionmark.156ae61dca601fa6d3f9a8642b735149.svg";
export { ForwardRef as ReactComponent };